import { format } from 'date-fns'

import { EMPTY_STRING } from '../../../constants/common'
import { DATE_FULL_FORMAT_FROM_TIME } from '../../../constants/date'
import { getUserListItemContentAdditionalText } from '../../../utils/user'

export function formatChatroomMessageTime(created) {
  if (!created) {
    return EMPTY_STRING
  }

  const date = new Date(created)

  if (Number.isNaN(date.getTime())) {
    return EMPTY_STRING
  }

  return format(date, DATE_FULL_FORMAT_FROM_TIME)
}

export function getChatroomMessageLikeCount(message) {
  return message?.like?.like_count || 0
}

export function isChatroomMessageLiked(message) {
  return Boolean(message?.like?.liked)
}

export function getChatroomMessageNextLikeState({ isLiked, message }) {
  const currentCount = getChatroomMessageLikeCount(message)

  return {
    like: {
      ...message?.like,
      like_count: isLiked ? currentCount + 1 : Math.max(0, currentCount - 1),
      liked: isLiked,
    },
  }
}

export function isOwnChatroomMessage({ currentUserId, message }) {
  return Boolean(currentUserId) && currentUserId === message?.owner
}

export function getChatroomMessageDeletedUpdate({ currentUserId, message }) {
  return {
    deleted: true,
    is_my_message: isOwnChatroomMessage({ currentUserId, message }),
  }
}

export function getChatroomMessageDisplayHeaderText({
  companyPostName,
  fullName,
  isOwnMessage,
  role,
  t,
}) {
  if (isOwnMessage) {
    return t('Chatroom.MessageOwnLabelKey')
  }

  return (
    fullName + getUserListItemContentAdditionalText({ companyPostName, role })
  )
}
